import React, { Fragment, useState } from "react";
import Table from "../../../Reporting/Echeances/Table";

import "./EncodingProgressionContent.local.scss";

const TVAProgressionContent = ({
  id,
  year,
  token,
  organization,
  zoneId
}) => {
  const balance_types = ["TVA"];
  const [balanceRefresh, setBalanceRefresh] = useState(false);
  
  return (
    <div className="tva_bilan_content">
      <Table
        token={token}
        organization={organization}
        year={year}
        collaboratorId={id}
        type={"TVA"}
        balance_types={balance_types}
        zoneId={zoneId}
        balanceRefresh={balanceRefresh}
        setBalanceRefresh={setBalanceRefresh}
      />
    </div>
  );
};

export default TVAProgressionContent;
